/** Legacy role name lists — kept until all sessions use role_id for HID staff detection. */
export const Constants = {
  PARTNER_STATUS: ["Active", "Registered", "Lapsed", "Inactive"],
  REGIONS: ["NAM", "LAM", "EMEA", "APAC", "Global", "Internal"],
  CONTRACT_STATUS: ["Active", "Inactive", "Scheduled"],
  HID_USER_ROLES: [
    "HID Admin",
    "HID Sales",
    "HID Technical Consultant",
    "HID Mobile Acceleration",
    "Partner Program Manager",
    "Partner Onboarding Manager",
  ],
  CONSULTANT_ASSIGNABLE_ROLES: ["HID Admin", "HID Technical Consultant", "Technical Consultant"],
};

/** roles.ID for the HID Sales role. */
export const HID_SALES_ROLE_ID = 8;
